import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Ouutstationtaxiserviceinmumbai() {



  const cardData = {
    keyword: " Outstation Taxi Service in Mumbai ",


"headingDescription": "Royal Route Cab offers reliable outstation taxi service in Mumbai, providing safe, comfortable, and affordable long-distance travel to all major cities, tourist destinations, hill stations, beaches, and pilgrimage sites across India. Whether you are planning a weekend getaway, family vacation, business trip, or one-way drop, our professional drivers and well-maintained vehicles ensure a smooth and stress-free journey. We offer flexible travel options including one-way trips, round trips, multi-city tours, and custom itineraries based on your travel needs. Our fleet includes sedans, SUVs, Innova, Ertiga, Innova Crysta, and Tempo Travellers suitable for solo travelers, families, and large groups. With transparent pricing, 24/7 availability, and easy booking, Royal Route Cab is your trusted choice for outstation taxi service in Mumbai.",

"topPlaces": [
  {
    "title": "Goa",
    "description": "Goa is one of India’s most popular outstation destinations known for its stunning beaches, nightlife, water sports, and Portuguese heritage. It is a top choice for road trips from Mumbai, Pune, and nearby cities, offering scenic highways, coastal views, and a vibrant holiday atmosphere perfect for families, couples, and group travelers."
  },
  {
    "title": "Lonavala",
    "description": "Lonavala is a famous hill station near Mumbai known for its lush green valleys, waterfalls, and pleasant weather, especially during monsoon season. It is a perfect short-distance getaway for weekend trips, trekking, and relaxation in nature."
  },
  {
    "title": "Mahabaleshwar",
    "description": "Mahabaleshwar is a scenic hill station in the Western Ghats known for strawberry farms, viewpoints, lakes, and cool climate. It is a popular outstation destination for families seeking a peaceful and refreshing break from Mumbai’s busy city life."
  },
  {
    "title": "Pune",
    "description": "Pune is a major educational and IT hub close to Mumbai, known for its cultural heritage, forts, and modern lifestyle. It is one of the most frequently traveled routes for business trips, weekend travel, and corporate cab bookings."
  },
  {
    "title": "Nashik",
    "description": "Nashik is a sacred city located on the banks of the Godavari River and is famous for Trimbakeshwar Jyotirlinga and Sula vineyards. It is a key destination for pilgrimage and wine tourism from Mumbai."
  },
  {
    "title": "Shirdi",
    "description": "Shirdi is one of India’s most important pilgrimage destinations dedicated to Sai Baba. Devotees from across the country visit the Sai Baba Temple, making it one of the most popular outstation taxi routes from Mumbai."
  },
  {
    "title": "Aurangabad",
    "description": "Aurangabad is known for historical monuments like Ajanta and Ellora Caves, which are UNESCO World Heritage Sites. It is a major cultural and heritage destination for long-distance road trips from Mumbai."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug is a coastal town near Mumbai known for its clean beaches, forts, and relaxing weekend vibe. It is a popular short trip destination for families and groups looking for a quick beach getaway."
  },
  {
    "title": "Surat",
    "description": "Surat is a major city in Gujarat known for its diamond industry, textile markets, and modern infrastructure. It is frequently traveled for business trips and intercity cab services from Mumbai."
  },
  {
    "title": "Ahmedabad",
    "description": "Ahmedabad is a cultural and commercial hub in Gujarat known for Sabarmati Ashram, heritage architecture, and vibrant food culture. It is a key long-distance outstation route from Mumbai for both tourism and business travel."
  }
],






services: [
  {
    name: "Outstation Taxi Service Mumbai",
    description: "Outstation taxi service Mumbai offers reliable and comfortable travel to nearby cities and long-distance destinations. This service is ideal for family vacations, business trips, and weekend getaways. Well-maintained vehicles and professional drivers ensure safety and comfort. It guarantees a smooth and hassle-free journey."
  },
  {
    name: "Mumbai Outstation Cab Service",
    description: "Mumbai outstation cab service provides flexible travel options for intercity journeys. Customers can choose from one way and round trip packages. Vehicles are designed for long-distance comfort. It ensures a reliable travel experience."
  },
  {
    name: "Outstation Taxi Booking Mumbai",
    description: "Outstation taxi booking Mumbai allows customers to reserve cabs easily for long-distance travel. Travelers can choose vehicle type, pickup location, and timing. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Outstation Cab Hire Mumbai",
    description: "Outstation cab hire Mumbai offers convenient rental options for long-distance travel. This service is ideal for business trips, family tours, and pilgrimages. Comfortable vehicles and experienced drivers enhance the journey. It ensures a pleasant travel experience."
  },
  {
    name: "Long Distance Taxi Mumbai",
    description: "Long distance taxi Mumbai provides reliable transportation for extended travel across cities and states. This service is perfect for road trips and corporate travel. Vehicles are maintained for highway performance. It guarantees a safe and comfortable journey."
  },
  {
    name: "Intercity Cab Service Mumbai",
    description: "Intercity cab service Mumbai offers seamless travel between cities with flexible pickup and drop options. This service is ideal for business and personal travel. Customers can choose different vehicle types. It ensures efficient and smooth travel."
  },
  {
    name: "Outstation Taxi Price Mumbai",
    description: "Outstation taxi price Mumbai varies based on distance, vehicle type, and trip duration. Transparent pricing ensures no hidden charges. Customers can choose from budget and premium options. It helps in planning travel expenses efficiently."
  },
  {
    name: "Outstation Cab Fare Mumbai",
    description: "Outstation cab fare Mumbai is designed to be competitive and affordable for long-distance travel. Fare depends on route and vehicle selection. Customers receive clear pricing details before booking. It ensures cost-effective travel."
  },
  {
    name: "One Way Outstation Taxi Mumbai",
    description: "One way outstation taxi Mumbai offers cost-effective travel without return charges. This service is ideal for single-side journeys. Flexible pickup options enhance convenience. It ensures smooth and economical travel."
  },
  {
    name: "Round Trip Outstation Cab Mumbai",
    description: "Round trip outstation cab Mumbai provides complete travel solutions including return journeys. This service is ideal for vacations and business trips. Flexible schedules and comfortable vehicles enhance convenience. It ensures a hassle-free experience."
  },
  {
    name: "Cheap Outstation Taxi Mumbai",
    description: "Cheap outstation taxi Mumbai offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Transparent pricing ensures no hidden charges. It ensures economical travel."
  },
  {
    name: "Best Outstation Cab Service Mumbai",
    description: "Best outstation cab service Mumbai ensures top-quality vehicles and professional drivers for long-distance travel. This service focuses on comfort, safety, and punctuality. It guarantees a reliable and premium journey."
  },
  {
    name: "Airport Outstation Taxi Mumbai",
    description: "Airport outstation taxi Mumbai provides direct long-distance travel from Mumbai airport to various destinations. This service is ideal for travelers arriving from flights. Professional drivers ensure timely service. It guarantees a smooth journey."
  },
  {
    name: "SUV Outstation Taxi Mumbai",
    description: "SUV outstation taxi Mumbai offers spacious and comfortable travel for families and groups. SUVs provide extra space and better performance for long-distance journeys. It ensures a comfortable travel experience."
  },
  {
    name: "Sedan Outstation Cab Mumbai",
    description: "Sedan outstation cab Mumbai is ideal for individuals and small families seeking affordable long-distance travel. Sedans offer smooth rides and good mileage. Professional drivers ensure safe travel. It ensures a pleasant journey."
  }
],

tableData: [
  ["Outstation Taxi Service Mumbai", "Mumbai Outstation Cab Service"],
  ["Outstation Taxi Booking Mumbai", "Outstation Cab Hire Mumbai"],
  ["Long Distance Taxi Mumbai", "Intercity Cab Service Mumbai"],
  ["Outstation Taxi Price Mumbai", "Outstation Cab Fare Mumbai"],
  ["One Way Outstation Taxi Mumbai", "Round Trip Outstation Cab Mumbai"],
  ["Cheap Outstation Taxi Mumbai", "Best Outstation Cab Service Mumbai"],
  ["Airport Outstation Taxi Mumbai", "SUV Outstation Taxi Mumbai"],
  ["Sedan Outstation Cab Mumbai", "Outstation Taxi Service Mumbai"]
],


whychoose: [
  {
    WhyChooseheading: "Reliable Outstation Taxi Service in Mumbai",
    WhyChoosedescription: "Royal Route Cabs offers dependable outstation taxi service in Mumbai for comfortable travel to nearby cities, hill stations, and long-distance destinations."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in long-distance routes, ensuring safe driving, smooth navigation, and timely arrival."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way taxi service, round-trip bookings, or multi-day travel packages based on your travel needs."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing including tolls, driver allowance, and all charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Taxi Availability",
    WhyChoosedescription: "Our outstation taxi service in Mumbai operates 24/7, allowing flexible travel anytime as per your schedule."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned to ensure a comfortable travel experience."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and mini buses for group travel."
  },
  {
    WhyChooseheading: "Trusted Outstation Travel Partner",
    WhyChoosedescription: "Royal Route Cabs is trusted by customers for outstation taxi bookings from Mumbai due to punctual service and reliable travel experience."
  }
]

};

const faqData = [
  { question: "Do you provide outstation taxi service in Mumbai?", answer: "Yes, Royal Route Cabs offers reliable outstation taxi services from Mumbai to various destinations." },
  { question: "What types of outstation trips are available?", answer: "We provide one-way, round-trip, and multi-day outstation taxi services." },
  { question: "Is taxi service available 24 hours?", answer: "Yes, our outstation taxi service operates 24/7." },
  { question: "Which vehicles are available for outstation travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, Tempo Travellers, and mini buses." },
  { question: "Are toll charges included in fare?", answer: "Toll charges are included or clearly mentioned during booking with no hidden costs." },
  { question: "Can I book taxi for long-distance travel?", answer: "Yes, we provide taxi services for long-distance travel across states." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for better availability and planning." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, and office anywhere in Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." },
  { question: "Can I customize my travel plan?", answer: "Yes, we provide fully customizable outstation travel packages." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Verma",
    feedback:
      "Booked outstation taxi from Mumbai with Royal Route Cabs. Smooth journey and very professional driver.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Sharma",
    feedback:
      "Excellent outstation taxi service. Clean car, on-time pickup, and comfortable travel experience.",
    rating: 5
  }
];












  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Outstation Taxi Service in Mumbai",
  "image": "https://www.royalroutecabs.com/assets/images/outstation-taxi-service-mumbai.jpg", // replace if needed
  "description": "Book outstation taxi service in Mumbai with Royal Route Cabs for safe, reliable, and affordable long-distance travel. Available for one-way and round-trip intercity journeys with sedan, SUV, Innova, and luxury cars. 24x7 service across India.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12", // per km approx starting (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/outstation-taxi-service-mumbai"
  }
};





  return (
    <div>
<Helmet>
  <title>Outstation Taxi Service in Mumbai | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book outstation taxi service in Mumbai with Royal Route Cabs. Affordable intercity travel with sedan, SUV, Innova & luxury cars. Safe drivers, 24x7 service, best fares."
  />

  <meta
    name="keywords"
    content="outstation taxi service mumbai, mumbai outstation cab service, outstation taxi booking mumbai, outstation cab hire mumbai, long distance taxi mumbai, intercity cab service mumbai, outstation taxi price mumbai, outstation cab fare mumbai, one way outstation taxi mumbai, round trip outstation cab mumbai, cheap outstation taxi mumbai, best outstation cab service mumbai, airport outstation taxi mumbai, suv outstation taxi mumbai, sedan outstation cab mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/49.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Ouutstationtaxiserviceinmumbai;